import Reveal from '@/components/base/Reveal';
import CtaLink from '@/pages/home/components/CtaLink';

const resultGrid = [
  { label: 'Goal', value: 'Achieve meaningful growth' },
  { label: 'Outcome', value: '200% Above Goal' },
  { label: 'Focus', value: 'Strategy + Systems + Lead Generation' },
];

export default function FeaturedStory() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left — visual */}
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/15 to-transparent blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <div className="relative w-full aspect-[4/3]">
                  <img
                    src="/assets/images/client-result.jpg"
                    alt="Featured client result — a residential roofing project"
                    title="Featured Client Result — Residential Roofing Growth"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-primary-500 text-background-950 px-3 py-1 text-xs font-label font-semibold">
                  <i className="ri-star-line"></i>
                  Featured Result
                </div>
              </div>
            </div>
          </Reveal>

          {/* Right — copy */}
          <Reveal delay={100}>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
              Featured Client Result
            </span>
            <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              From Growth Goal to 200% Beyond Target
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              This client came to Josh with a strong business but an
              inconsistent marketing system. Leads were unpredictable,
              attribution was unclear, and follow-up was slow — so the team
              could not see what was actually driving revenue.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              Josh helped identify the bottlenecks across strategy, systems, and
              lead generation, then rebuilt the flow so every dollar and every
              inquiry had a clear path to a customer. The result was a marketing
              system that produced growth beyond the original target.
            </p>

            <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {resultGrid.map((r) => (
                <div
                  key={r.label}
                  className="rounded-lg border border-white/8 bg-background-100 p-4">
                  <p className="text-xs font-label font-semibold uppercase tracking-wide text-foreground-600">
                    {r.label}
                  </p>
                  <p className="mt-1 text-sm font-heading font-semibold text-foreground-950">
                    {r.value}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <CtaLink>Apply to Build Your Growth Plan</CtaLink>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
